import { render } from "./ShowSndDetails.vue?vue&type=template&id=51207732"
import script from "./ShowSndDetails.vue?vue&type=script&lang=js"
export * from "./ShowSndDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__